import { ArrowDownward } from '@mui/icons-material';
import './App.css'
import Details from './components/Details'
import Third from './components/Third'
import {
  BrowserRouter as Router,
  Route,
  Link,
  Routes
} from "react-router-dom";
import Register from './components/Register'

function App() {

  return (
    <Router>
      <Routes>
        <Route path="/about/:slug" element={<Register/>}/>
        <Route path="/" element={<Home/>}/>
      </Routes>
    </Router>
  );
}

function Home(){
  return (
    <div className='App'>
      <div className='home'>
          <div className='title'>
            <div className='maint'>CSE UTSAV</div>
            <div className='yeart'>A 2022 Symposium</div>
          </div>
          <div className='desc'>
            <div className='descw'>On <span className='spand'>June 6</span>, we of the Computer Science Department of PSNACET are organizing a <span className='spand'>Symposium</span>. We are making it inter-college this year with a range of stirring events, both technical and non-technical. Registration is essential. And <span className='spand'>welcome</span>.</div>
            <div className='seew'><button className='seebtn'>Check it out!</button></div>
          </div>
      </div>
      <Details/>
      <Third/>
    </div>
  )
}

export default App;
